import { Loader2, Film, Image as ImageIcon, AlertTriangle } from "lucide-react";
import { fileUrl } from "../../lib/api";

const when = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });

const Thumb = ({ src, status }) => (
  <div className="aspect-video rounded-lg overflow-hidden bg-checker flex items-center justify-center">
    {status === "failed" ? <AlertTriangle className="w-5 h-5 text-red-400" />
      : status !== "done" ? <Loader2 className="w-5 h-5 animate-spin text-[#00ff87]" />
      : <img src={src} alt="" className="w-full h-full object-cover" />}
  </div>
);

const Item = ({ active, onClick, testid, children }) => (
  <button data-testid={testid} onClick={onClick}
    className={`text-left rounded-xl p-2 border transition-colors ${active ? "border-[#00ff87]" : "border-[#1e2638] hover:border-gray-500"}`}>
    {children}
  </button>
);

export const History = ({ stills, videos, activeVideoId, viewStillId, onPickStill, onPickVideo }) => {
  const items = [
    ...videos.map((v) => ({ ...v, kind: "video" })),
    ...stills.map((s) => ({ ...s, kind: "still" })),
  ].sort((a, b) => b.created_at.localeCompare(a.created_at));

  return (
    <div className="rise">
      <div className="font-mono-ui text-[11px] uppercase tracking-[0.2em] text-emerald-400/80 mb-4">History</div>
      {items.length === 0 ? (
        <p data-testid="history-empty" className="text-sm text-gray-500">Your stills and videos will show up here.</p>
      ) : (
        <div data-testid="history-list" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {items.map((it) => (
            <Item key={it.id} testid={`history-item-${it.id}`}
              active={it.kind === "video" ? it.id === activeVideoId : !activeVideoId && it.id === viewStillId}
              onClick={() => (it.kind === "video" ? onPickVideo(it.id) : onPickStill(it.id))}>
              <Thumb status={it.status} src={fileUrl(it.kind === "video" ? it.still_path : it.path)} />
              <div className="flex items-center gap-1.5 mt-2 text-[11px] text-gray-400 font-mono-ui">
                {it.kind === "video" ? <Film className="w-3 h-3" /> : <ImageIcon className="w-3 h-3" />}
                {it.kind === "video" ? `Video ${it.duration}s` : "Still"} · {when(it.created_at)}
              </div>
            </Item>
          ))}
        </div>
      )}
    </div>
  );
};
